import axios from '../axios'

/* 
 * 机构管理模块
 */

// 保存
export const save = (data) => {
    return axios({
        url: '/admin/dept/save',
        method: 'post',
        data
    })
}
// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/admin/dept/delete',
        method: 'post',
        data
    })
}
// 查询机构树
export const findDeptTree = (data) => {
    return axios({
        url: '/admin/dept/findTree',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/dept.js